import { ButtonGroup, DangerButton, Modal, QuietButton } from "@nulogy/components";
import useDeleteConfirmationModal from "hooks/state/useDeleteConfirmationModal";
import React from "react";

export default function DeleteConfirmationModal({ onDelete, title, message }) {
  const { close: closeModal, isOpen, data } = useDeleteConfirmationModal();

  const handleDelete = () => {
    onDelete(data);
    closeModal();
  };

  const close = () => {
    closeModal();
  };

  const footerContent = (
    <ButtonGroup>
      <DangerButton className="spec-delete-in-modal" data-testid="modal-delete-button" onClick={handleDelete}>
        Yes, delete
      </DangerButton>
      <QuietButton onClick={close}>Cancel</QuietButton>
    </ButtonGroup>
  );

  return (
    <Modal ariaHideApp={false} footerContent={footerContent} isOpen={isOpen} onRequestClose={close} title={title}>
      {message}
    </Modal>
  );
}
